import { dateEquals, parseDate, getToday } from './dateHelper';

export function getDigitalCollectionNotification(
  emails,
  routerQuery,
  digitalCollectionAccepted,
  hasSentNotificationEmail,
  page
) {
  if (hasSentNotificationEmail) {
    return getNotification(2);
  }
  const { email, token } = routerQuery;
  if (email !== undefined || token !== undefined) {
    return { severity: 'success', message: 'Þú hefur staðfest netfangið þitt' };
  } else if (emails !== null) {
    if (emails.length == 0) {
      // Payer has not provided an email -> Ask for an email
      return getNotification(4);
    } else if (digitalCollectionAccepted !== undefined) {
      const hasConfirmedEmail = emails.some((x) => x.confirmed !== undefined);

      if (!hasConfirmedEmail) {
        const today = getToday();
        const digitalCollection = parseDate(digitalCollectionAccepted);

        if (dateEquals(today, digitalCollection)) {
          // Payer just accepted DC but has not confirmed his email -> Remind payer to confirm email
          return getNotification(0);
        } else {
          // Payer has accepted DC but has not confirmed his email -> Remind payer to confirm email
          return getNotification(3);
        }
      }
    } else {
      // Payer has not accepted DC -> Ask payer to enroll in DC
      return getNotification(1);
    }
  }
  function getNotification(notification) {
    switch (notification) {
      case 0:
        return {
          severity: 'success',
          message:
            'Mundu að til að fá innheimtubréfin í tölvupósti þarftu að staðfesta netfangið þitt með því að smella á hlekkinn í póstinum sem við sendum þér.',
        };
      case 1:
        return {
          severity: 'info',
          message:
            page != 'settings'
              ? 'Þú getur fengið tölvupóst í stað bréfpósts. Þannig færðu bréf vegna skulda sem kunna að koma til innheimtu hjá okkur fyrr en ella og getur brugðist hraðar við. Sjá '
              : 'Þú getur fengið stafrænar áminningar vegna skulda sem kunna að koma til innheimtu hjá okkur. Með því getur þú brugðist hraðar við en ella.​',
          appendSettingsLink: page != 'settings' ? true : false,
        };
      case 2:
        return {
          severity: 'info',
          message:
            'Við höfum sent þér tölvupóst þar sem við biðjum þig um að smella á tengil til að staðfesta að þetta sé netfangið þitt.',
        };
      case 3:
        return {
          severity: 'warning',
          message:
            page != 'settings'
              ? 'Þú samþykktir að fá innheimtubréf frá okkur með tölvupósti, en átt eftir að staðfesta netfangið þitt. Ef þú vilt fá staðfestingarpóstinn endursendann þá skaltu fara inn á '
              : 'Þú samþykktir að fá innheimtubréf frá okkur með tölvupósti, en átt eftir að staðfesta netfangið þitt.',
          appendSettingsLink: page != 'settings' ? true : false,
        };
      case 4:
        return {
          severity: 'warning',
          message:
            page != 'settings'
              ? 'Þú ert ekki með skráð netfang. Til að við getum svarað fyrirspurnum frá þér hér á vefnum þá þarftu að skrá netfang.  Sjá '
              : 'Þú ert ekki með skráð netfang. Til að við getum svarað fyrirspurnum frá þér hér á vefnum þá þarftu að skrá netfang.',
          appendSettingsLink: page != 'settings' ? true : false,
        };

      default:
        break;
    }
  }
}
